import ConfigureFeedModal from './ConfigureFeedModal';

export default ConfigureFeedModal;
